import React from 'react';

/**
 * Changelist publish dates table.
 * Shows CL number, publish date (Pacific), and record count.
 *
 * @param {Object} props
 * @param {Array} props.data - Array of { changelist, publishDate, recordCount }
 * @param {boolean} props.loading
 */
function ChangelistDates({ data, loading }) {
  if (loading) {
    return <div className="cl-dates-loading">Loading changelist data...</div>;
  }

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="cl-dates">
      <h4>Changelist Publish Dates</h4>
      <div className="cl-dates-table-wrapper">
        <table className="cl-dates-table">
          <thead>
            <tr>
              <th>ClientChangelist</th>
              <th>ClientPublishDate (PST)</th>
              <th>Record Count</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={row.changelist || i}>
                <td>{row.changelist}</td>
                <td>{formatPacific(row.publishDate)}</td>
                <td className="cl-dates-count">{row.recordCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function formatPacific(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return dateStr;
  }
}

export default ChangelistDates;
